"use client";
import type { CmsLocaleInputType } from "@workspace/casino_core/schema";
import { RewardCenterWhiteboard } from "@workspace/reward-ui";
import type { FC } from "react";

type Props = {
  isDevConsoleEnabled: boolean;
  locale: string;
  site: string;
};

// Client boundary only: everything else lives in @workspace/reward-ui
const RewardCenterWrap: FC<Props> = ({ isDevConsoleEnabled, locale, site }) => (
  <RewardCenterWhiteboard
    isDevConsoleEnabled={isDevConsoleEnabled}
    locale={locale as CmsLocaleInputType}
    site={site}
  />
);

export default RewardCenterWrap;
